'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.flashErrorMessage = exports.flashSuccessMessage = exports._addMessage = exports.removeMessage = exports.clearMessages = exports.flashMessage = exports.ADD_MESSAGE_ACTION_TYPE = exports.REMOVE_MESSAGE_ACTION_TYPE = exports.CLEAR_MESSAGES_ACTION_TYPE = exports.FLASH_MESSAGE_ACTION_TYPE = undefined;
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _reduxActions = require('redux-actions');
var FLASH_MESSAGE_ACTION_TYPE = exports.FLASH_MESSAGE_ACTION_TYPE = '@@redux-flash/FLASH';
var CLEAR_MESSAGES_ACTION_TYPE = exports.CLEAR_MESSAGES_ACTION_TYPE = '@@redux-flash/CLEAR_MESSAGES';
var REMOVE_MESSAGE_ACTION_TYPE = exports.REMOVE_MESSAGE_ACTION_TYPE = '@@redux-flash/REMOVE_MESSAGE';
var ADD_MESSAGE_ACTION_TYPE = exports.ADD_MESSAGE_ACTION_TYPE = '@@redux-flash/ADD_MESSAGE';
var flashMessage = exports.flashMessage = function flashMessage(message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: FLASH_MESSAGE_ACTION_TYPE,
    payload: {
      message: message,
      options: options
    }
  };
};
var clearMessages = exports.clearMessages = (0, _reduxActions.createAction)(CLEAR_MESSAGES_ACTION_TYPE);
var removeMessage = exports.removeMessage = (0, _reduxActions.createAction)(REMOVE_MESSAGE_ACTION_TYPE);
var _addMessage = exports._addMessage = (0, _reduxActions.createAction)(ADD_MESSAGE_ACTION_TYPE);
var flashSuccessMessage = exports.flashSuccessMessage = flashMessage;
var flashErrorMessage = exports.flashErrorMessage = function flashErrorMessage(message, options) {
  return flashMessage(message, _extends({
    isError: true
  }, options));
};